import { CommandPalette } from './command-palette';
import { vulnerabilitySearchScope } from './vulnerability-search/vulnerability-search-scope';

/**
 * Quick Search: the command palette hosting the vulnerability scope.
 */
export const QuickSearchModal = () => (
  <CommandPalette
    label="Quick Search"
    modalId="quickSearch"
    scopes={[vulnerabilitySearchScope]}
  />
);

export default QuickSearchModal;
